/** ************************************************************************************
 * MAPS
 */
var selectedStopCode = null;
var maps = new Array();
var stopMarkers = [];
var stopMarkerIndexes = [];
var stopsIntoRequestId = null;
var stops = [];
var changedPosition = 0;
var stopsIntoCall = null;
var map = null;
var stopsRequested = false;
var previousMarkers = [];

var clusterStyles = [
    {
        url: '/images/icon-cluster.png',
        height: 27,
        width: 27
    }, {
        url: '/images/icon-cluster.png',
        height: 27,
        width: 27
    }, {
        url: '/images/icon-cluster.png',
        height: 27,
        width: 27
    }, {
        url: '/images/icon-cluster.png',
        height: 27,
        width: 27
    }, {
        url: '/images/icon-cluster.png',
        height: 27,
        width: 27
    }
];

/* ************************************************************************************
 * SEARCH
 */

var app = angular.module('maps', ['ngSanitize', 'ngRoute', 'angularSpinner']).config(function($interpolateProvider, usSpinnerConfigProvider){
    $interpolateProvider.startSymbol('{[{').endSymbol('}]}');

    usSpinnerConfigProvider.setDefaults({
        lines: 13,
        length: 50,
        width: 15,
        radius: 60,
        scale: 0.15,
        color: '#818181'
    });
});

//
app.controller('mapsController', ['$scope', '$http', '$timeout', '$q', 'usSpinnerService', '$rootScope', '$element', function($scope, $http, $timeout, $q, usSpinnerService, $rootScope, $element){

    $scope.url = Routing.generate("autocomplete_stop"); // The url of our search
    $scope.activeItemIndex = 0;
    $scope.dropdownVisible = false;
    $scope.defaultDropdownItems = '';
    $scope.dropdownItems = $scope.defaultDropdownItems || [];

    var pressedDropdown = false;

    /**
     * resetta il parametro activeItemIndex
     * per poter ripartire da 0 alla successiva ricerca
     */
    $scope.$watch('dropdownItems', function(newValue, oldValue) {
        if (!angular.equals(newValue, oldValue)) {
            // If new dropdownItems were retrieved, reset active item
            $scope.setActive(0);
        }
    });

    $scope.setActive = function(itemIndex) {
        $scope.activeItemIndex = itemIndex;
    };

    /**
     * Focus sul campo input
     */
    $scope.inputFocus = function() {
        $scope.setActive(0);
        showDropdown();
    };

    /**
     * Blur sul campo input
     *
     * @param event
     */
    $scope.inputBlur = function(event) {
        if (pressedDropdown) {
            // il blur viene attivato prima dell'evento click, il che significa che un clic su una voce di menu a discesa
            // non sarà attivato se ci nascondiamo l'elenco a discesa qui.
            pressedDropdown = false;
            return;
        }

        // se il value del campo input nascosto è vuoto
        // cancella il contenuto del campo input principale
        if($("#stop").val() == "") {
            $scope.checkForCleanStopSearch();
        }

        hideDropdown();
    };

    $scope.dropdownPressed = function() {
        pressedDropdown = true;
    }

    /**
     * apre finestra dropdown
     */
    var showDropdown = function () {
        $scope.dropdownVisible = true;
    };

    /**
     * chiude finestra dropdown
     */
    var hideDropdown = function() {
        $scope.dropdownVisible = false;

        // imposto l'altezza della lista a 0 per risolvere un problema su FF
        $('.search-list').css('height', '0');
    }

    /**
     * muove classe active alla voce di lista precedente
     */
    var selectPreviousItem = function() {
        var prevIndex = $scope.activeItemIndex - 1;
        if (prevIndex >= 0) {
            $scope.setActive(prevIndex);
        }
    };

    /**
     * muove classe active alla voce di lista successiva
     */
    var selectNextItem = function() {
        var nextIndex = $scope.activeItemIndex + 1;
        if (nextIndex < $scope.dropdownItems.length) {
            $scope.setActive(nextIndex);
        }
    };

    /**
     * aggiunge la voce corrente con classe active
     */
    var selectActiveItem = function()  {
        if ($scope.activeItemIndex >= 0 && $scope.activeItemIndex < $scope.dropdownItems.length) {
            $scope.selectItem($scope.dropdownItems[$scope.activeItemIndex]);
        }
    };

    /**
     * seleziona la voce corrente
     * e mostra i risultati
     *
     * @param item
     */
    $scope.selectItem = function(item) {
        $scope.selectedItem = item;
        hideDropdown();
        $scope.dropdownItems = [item];

        $scope.checkForCleanStopSearch();
        $scope.setStopString(item.description);
        $scope.setStopValue(item.code);
        $scope.setStopDetails(item.code, item.name, item.lat, item.lng);
    };

    /**
     * accessibilità: permette di muoversi con i tasti da tastiera
     */
    $element.bind("keydown keypress", function (event) {

        switch (event.which) {
            case 38: //up
                $scope.$apply(selectPreviousItem);
                break;
            case 40: //down
                $scope.$apply(selectNextItem);
                break;
            case 13: // return
                if ($scope.dropdownVisible && $scope.dropdownItems && $scope.dropdownItems.length > 0) {
                    // only preventDefault when there is a list so that we can submit form with return key after a selection is made
                    event.preventDefault();
                    $scope.$apply(selectActiveItem);
                }
                break;

        }
    });

    /*
     * funzione eseguita all'ng-change della stringa di input nel campo "partenza"
     */
    var canceller = $q.defer();
    $scope.findStops = function() {

        canceller.resolve("cancelled"); // Resolve the previous canceler
        canceller = $q.defer();

        $scope.stopValue = null;

        $scope.geolocationResultsInputSearchStop = [];
        $scope.showNoResultsInputSearchStop = false;

        $scope.dropdownItems = $scope.defaultDropdownItems || [];

        var string = $scope.stopString;
        //var date = $scope.dateSelected;
        //var date = $('#input-start-date').val();
        //var time = $('#input-start-time').val();

        //console.log(date);

        if(string != "") {
            usSpinnerService.spin('spinner-loading-input-search-stop');

            $scope.search(string);
        } else {
            $scope.resetInputSearchStop();
        }
    };

    $scope.setStopString = function(description) {
        $scope.stopString = description;
    };

    $scope.setStopDetails = function(code, name, lat, lng) {

        $("#selected-stop").html(name);
        $("#selected-stop-wrapper").show();
        selectedStopCode = code;
        centerCurrentMapTo(lat, lng);
    };

    /**
     * resetta la ricerca
     */
    $scope.resetInputSearchStop = function() {

        $scope.geolocationResultsInputSearchStop = [];
        $scope.showNoResultsInputSearchStop = false;
    };

    /**
     * CALL
     */
    var searchPromise;
    var geoRequestId = uniqid();
    $scope.search = function(string) {

        $scope.showNoResultsInputSearchStop = false;
        $scope.geolocationResultsInputSearchStop = [];

        if(searchPromise){
            $timeout.cancel(searchPromise);
        }
        searchPromise = $timeout(function () {

            geoRequestId = uniqid();

            $http.get($scope.url, {
                "data" : $scope,
                "params": {
                    string: string,
                    //date: $("#input-start-date").val(),
                    geoRequestId: geoRequestId,
                    fastSearch: true
                },
                timeout: canceller.promise
            }).then(function(data, status) {

                usSpinnerService.stop('spinner-loading-input-search-stop');

                // imposto l'altezza della lista a 'auto' per risolvere un problema su FF
                $('.search-list').css('height', 'auto');

                if(data.data.results.length == 0) {
                    $scope.showNoResultsInputSearchStop = true;
                }

                if(data.data.geoRequestId == geoRequestId) {
                    $scope.geolocationResultsInputSearchStop = data.data.results;
                    $scope.dropdownItems = $scope.geolocationResultsInputSearchStop;
                }

            }, function () {
                return [];
            });
        },500);
    };

    $scope.cancel = function(){
        canceller.resolve("user cancelled");
    };

    $scope.setStopValue = function(stopCode){
        $scope.stopValue = stopCode;
        $("#stop").val(stopCode);
        $("#stop").trigger("change");
    };
    $rootScope.setRootVariablesOnChange = function() {
        $rootScope.closeSelection = false;
    }

    $scope.checkForCleanStopSearch = function(){

        $scope.stopString = "";
        $("#stop-search").val("");
        usSpinnerService.stop('spinner-loading-input-search-stop');
        $scope.resetInputSearchStop();

    };
}]);